export const siteConfig = {
  name: '年轻的妈妈',
  tagline: '新手育儿全攻略',
  description: '专为年轻的妈妈打造的育儿指南，涵盖新生儿护理、产后恢复、母乳喂养、宝宝早教及妈妈自我成长，帮助每一位年轻的妈妈从容应对育儿挑战，找到属于自己的育儿节奏与生活平衡。',
  url: 'https://young-mama.com',
  logo: '年轻的妈妈',
  foundingYear: 2023,
  email: 'hello@young-mama.com',
  phone: '400-123-4567',
  wechat: 'youngmama_official',
  address: '北京市朝阳区建国路88号SOHO现代城A座1208室',
  socialLinks: {
    weibo: 'https://weibo.com/youngmama',
    xiaohongshu: 'https://xiaohongshu.com/youngmama',
    douyin: 'https://douyin.com/youngmama',
  },
};

export const aboutContent = {
  brandStory: {
    title: '我们的故事',
    paragraphs: [
      '2023年，一位刚成为妈妈的年轻女性在深夜喂奶时萌生了一个想法：为什么没有一个地方，能一站式获取所有新手妈妈需要的知识？',
      '从新生儿护理到产后恢复，从母乳喂养到早教启蒙，太多信息散落在各处，真假难辨。作为一位新手妈妈，她深知育儿路上的焦虑与迷茫——每一个决定都关乎宝宝的健康，却常常找不到可靠的指导。',
      '于是，"年轻的妈妈"诞生了。我们聚集了儿科医生、泌乳顾问、营养师、早教专家和心理咨询师，希望为每一位年轻妈妈提供科学、温暖、实用的育儿知识。',
      '我们相信，育儿不应该是孤独的旅程。每一位妈妈都应该在这个全新的角色中，找到属于自己的节奏与自信。',
    ],
  },
  mission: '用科学与爱，陪伴每一位年轻妈妈从容走过育儿旅程。',
  values: [
    {
      title: '科学专业',
      description: '所有内容由各领域专家审核，确保信息的准确性和科学性。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '温暖陪伴',
      description: '用温暖的语言和真实的案例，让每一位妈妈感受到理解和支持。',
      icon: 'ri-heart-line',
    },
    {
      title: '实用落地',
      description: '我们提供的不只是知识，更是可以立刻操作的解决方案。',
      icon: 'ri-tools-line',
    },
    {
      title: '共同成长',
      description: '育儿是妈妈和宝宝一起成长的过程，我们陪伴每一步。',
      icon: 'ri-seedling-line',
    },
  ],
  teamIntro: '我们的团队由一群热爱育儿事业的专业人士组成，包括儿科医生、国际认证泌乳顾问（IBCLC）、注册营养师、儿童早期教育专家和国家二级心理咨询师。每一位内容创作者都有5年以上的专业经验，确保每一篇文章都值得信赖。',
};

export const contactInfo = {
  email: 'hello@young-mama.com',
  phone: '400-123-4567',
  wechat: 'youngmama_official',
  address: '北京市朝阳区建国路88号SOHO现代城A座1208室',
  workingHours: '周一至周五 9:00 - 18:00',
};